import React from "react";
import Navbar from "../global-components/navbar";

import Footer from '../global-components/footer';

import { Helmet } from "react-helmet";
import ServiceOne from "../section-components/service-one";
import PageHeaderService from "../global-components/page-headerservice";
import PageHeaderTerms from "../global-components/termsHeader";
import OurTerms from "../section-components/ourTerms";
import Page_header from "../global-components/page-header";





const TermsCondition = () => {

    return (
        <div>
            {/* <Helmet>
                <title>Real Estate Services in Dubai | Trinest Sky – Off-Plan & Luxury Experts</title>
                <meta name="description" content="Explore expert real estate services in Dubai – from off-plan property sales and luxury homes to international investment advisory. Contact us today." />
            </Helmet> */}
            <Navbar />
            <Page_header headertitle="Terms" />

            <OurTerms />
            <Footer />
        </div>
    )
}

export default TermsCondition